import request from '@/utils/request'

// 分页查询字典数据列表
export function pageDictData(query) {
    return request({
        url: '/pa/xcx/paxcxpro/admin/dictionary-data/page',
        method: 'post',
        data: query
    })
}

// 查询字典数据详细
export function getData(dictCode) {
    return request({
        url: '/pa/xcx/paxcxpro/admin/dictionary-data/detail',
        method: 'post',
        data: dictCode
    })
}

// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
    return request({
        url: '/pa/xcx/paxcxpro/admin/dictionary-data/' + dictType,
        method: 'get'
    })
}

// 新增字典数据
export function addData(data) {
    return request({
        url: '/pa/xcx/paxcxpro/admin/dictionary-data/add',
        method: 'post',
        data: data
    })
}

// 修改字典数据
export function updateData(data) {
    return request({
        url: '/pa/xcx/paxcxpro/admin/dictionary-data/update',
        method: 'post',
        data: data
    })
}

// 删除字典数据
export function delData(dictCode) {
    return request({
        url: '/pa/xcx/paxcxpro/admin/dictionary-data/delete',
        method: 'post',
        data: dictCode
    })
}
